export function round(price: number) {
  return price.toFixed(2);
}
